import React, { useEffect, useRef } from "react";
import { useProductsContext } from "../context/Context";
import { OtherProjectsData } from "../data";
import Title from "./Title";
import Button from "./Button";
import { ImArrowUpRight2 } from "react-icons/im";

const Others_projects = () => {
  const { CursorBig, CursorSmall, showCurText, hideCurText } =
    useProductsContext();

  return (
    <>
      <section className="other-projects">
        <Title title="other project"></Title>

        <div className="row">
          <div className="other-projects__list">
            {OtherProjectsData.map(
              (
                { project_name, project_title, project_link, image_url },
                index
              ) => {
                return (
                  <a
                    href={project_link}
                    target="_blank"
                    className="project__link"
                    onMouseOver={() => {
                      CursorBig();
                      showCurText("source code");
                    }}
                    onMouseOut={() => {
                      CursorSmall();
                      hideCurText();
                    }}
                    key={index}
                    rel="noopener noreferrer">
                    {/* <li
                      className={`other-projects__item other-projects__item--${index}`}
                    >
                      <h3 className="heading">{project_name}</h3>
                      <p className="p-text">{project_title}</p>

                      <ImArrowUpRight2 />
                    </li> */}
                    <img src={image_url} className="bg-image" alt="" />
                    <div className={`other-projects__item`}>
                      <h3 className="heading">{project_name}</h3>
                      <p className="p-text">{project_title}</p>
                      <ImArrowUpRight2 />
                    </div>
                  </a>
                );
              }
            )}
          </div>
        </div>
        <Button
          text="all projects on github"
          link="https://github.com/maruf1137"></Button>
      </section>
    </>
  );
};

export default Others_projects;
